import { CreateBookingV3Component } from "@/app/infrastructures/dependencies/modules/CreateBookingV3Component";
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { CreateBookingV3Presenter } from "../presenters/CreateBookingV3Presenter";
import { BookingPresenter } from "../presenters/BookingPresenter";
import { MiddlewarePresenter } from "../presenters/MiddlewarePresenter";
import { ShipmentBookingPresenter } from "../presenters/ShipmentBookingPresenter";
import { AddBookingCorporate } from "@/data/payload/api/BookingRequest";
import { AddShipmentBooking } from "@/data/payload/api/ShipmentBookingRequest";
import { ListSttPresenter } from "../presenters/ListSttPresenter";

CreateBookingV3Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "create-booking-v3"
})
class CreateBookingV3Store extends VuexModule {
  @Action
  getShipmentIdList(params: { id: string; limit: number; page: number }) {
    return container
      .resolve(BookingPresenter)
      .getShipmentIdList(params.id, params.limit, params.page);
  }

  @Action
  public async getShipmentDetailFromMiddleware(params: { ticketCode: string }) {
    return container.resolve(MiddlewarePresenter)
      .getShipmentDetailMiddleWare(params.ticketCode);
  }

  @Action
  public async addShipmentBooking(params: { payload: AddShipmentBooking }) {
    return container.resolve(ShipmentBookingPresenter)
      .addShipmentBooking(params.payload);
  }
  
  @Action
  public getListStt(params: {
    page: number;
    limit: number;
    destinationCityId: number;
    userType: string;
    bookedBy: string;
    fromDate: string;
    endDate: string;
    sttNumber: string;
    bookedType: string;
  }) {
    return container.resolve(ListSttPresenter)
      .getSttList(
        params.page,
        params.limit,
        params.destinationCityId,
        params.userType,
        params.bookedBy,
        params.fromDate,
        params.endDate,
        params.sttNumber,
        params.bookedType
      )
  }

  errorChWeightMaxGapShipmentMp = false;
  @Mutation
  setErrorChWeightMaxGapShipmentMp(value: boolean) {
    this.errorChWeightMaxGapShipmentMp = value;
  }
  isDirty = false;

  @Mutation
  setDirty(value: boolean) {
    this.isDirty = value;
  }
}

export const CreateBookingV3Controller = getModule(CreateBookingV3Store);
